import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProcessoGrupo } from '../../../models/processo-grupo.model';
import { ProcessoGrupoService } from '../../../services/processo-grupo.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';


@Component({
  selector: 'app-grupo-list',
  templateUrl: './grupo-list.component.html',
  styleUrls: ['./grupo-list.component.scss']
})
export class GrupoListComponent extends BaseListComponent<ProcessoGrupo> implements OnInit{

  processoGrupoList:ProcessoGrupo[];
  idProcesso: number;
  ordenacao: number = 0;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ProcessoGrupoService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.loading();
    this.idProcesso = this.activatedRoute.parent.snapshot.params.id;
    
    this.initLoadDataTable();
  }

  initLoadDataTable(){
    this.addSub(
      this.myService.getListAll(this.idProcesso).subscribe({
        next: (res) => {
          this.processoGrupoList = res;
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  editar(id: number) {
    return ['/pre-projeto/processos/grupos/', id];
  }


  drop(event: CdkDragDrop<string[]>, indexGroup: number) {
    moveItemInArray(this.processoGrupoList[indexGroup]?.items, event.previousIndex, event.currentIndex);

    this.processoGrupoList[indexGroup]?.items.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
  }

  salvarOrdem(indexGroup: number) {
    this.loading();
    let obj = {
      pp_process_group_order: this.processoGrupoList[indexGroup]?.items
    }
    this.myService.updateOrdem(obj).subscribe({
      next: (res) => {
        this.msgSuccess('Ordem salva com sucesso!');
        this.processoGrupoList[indexGroup].active_ord = false
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
  
  voltar() {
    this.navigation.back(['/pre-projeto', 'processos']);
  }
}
